<h3 class="text-center mt-0 m-b-15">
  <img src="/assets/v2/img/logo-color-baseline-V62-slogan-black.svg" height="60" alt="logo"> 
</h3>
<div class="row col-lg-12 col-md-12 col-sm-12 col-12">
  <div class="col-lg-2 col-md-2">
    <img class="pic-login-2" src="/assets/v2/img/decisiel-bg02.jpg">
  </div>
  <div class="col-lg-10 col-md-10 col-sm-12 col-12 login-form">
    <div class="center-screen container-login100 bodybg-color">
      <p-card class="customCard">
        <p-header class="customHeader">
          <span class="headerTitle">
            S'authentifier
          </span>
        </p-header>
        <div class="row">
          <div class="col">
            <form [formGroup]="loginForm" (ngSubmit)="login()" action="#" novalidate>
              <div class="alert alert-danger" *ngIf="submitted && loginError">
                Login ou mot de passe incorrect.
              </div>
              <div class="input-group form-group">

                <input name="Email" formControlName="Email" style="height: calc(1.5em + .5rem + 2px) !important;"
                       type="text" class="form-control" placeholder="Saisir votre e-mail"
                       [ngClass]="{ 'is-invalid': submitted && f.Email.errors }">

                <div *ngIf="submitted && f.Email.errors" class="text-danger invalid-feedback">
                  <div *ngIf="f.Email.errors.required">Email obligatoire.</div>
                  <div *ngIf="f.Email.errors.maxlength">Maximum 100 caractères.</div>
                  <div *ngIf="f.Email.errors.pattern">Format invalide.</div>
                </div>
              </div>
              <div class="input-group form-group">
                <input name="Password" type="password" class="form-control" style="height: calc(1.5em + .5rem + 2px) !important;"
                       promptLabel="Saisir un mot de passe" formControlName="Password"
                       placeholder="Mot de passe" [ngClass]="{ 'is-invalid': submitted && f.Password.errors }">

                <div *ngIf="submitted && f.Password.errors" class="text-danger invalid-feedback" style="font-size: 80%; color: #dc3545;">
                  <div *ngIf="f.Password.errors.required">Mot de passe obligatoire.</div>
                  <div *ngIf="f.Password.errors.pattern">Format invalide.</div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="input-group form-group remember-me-container">
                    <div class="input-group-prepend">
                      <p-checkbox formControlName="RememberMe" name="rememberMe" [binary]="true"></p-checkbox>
                    </div>
                    <span class="remember-me-label">Se souvenir de moi</span>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="input-group form-group remember-me-container">
                    <a href="#" routerLink="/lostPassword">Mot de passe oublié ?</a>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-8">
                  <div #recaptcha></div>
                </div>
                <div class="col-md-4 col-connect-action">
                  <button type="submit" class="btn btn-primary" (click)="login()">
                    <span class="btn-label">
                      <i class="pi pi-unlock"></i>
                    </span>Se connecter
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" style="color:#B22222;"
                          role="status" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</div>

